import { render, staticRenderFns } from "./BMPBloqueioMobile.vue?vue&type=template&id=32284b0d&scoped=true"
import script from "./BMPBloqueioMobile.vue?vue&type=script&lang=js"
export * from "./BMPBloqueioMobile.vue?vue&type=script&lang=js"
import style0 from "./BMPBloqueioMobile.vue?vue&type=style&index=0&id=32284b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32284b0d",
  null
  
)

export default component.exports